import { ReleaseBillableEventDto } from '../dtos/release-billable-event.dto';

/**
 * Release billable events request DTO
 */
export class ReleaseBillableEventsRequest {
	records!: ReleaseBillableEventDto[];
}
